export const Groups = [
	{ label: 'consumable'},
	{ label: 'equipment'},
	{ label: 'accessory'},
]



// WEBPACK FOOTER //
// ./src/config/enum/Groups.js